import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setIsScrolled(currentScrollY > 20);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isVisible ? 'translate-y-0' : '-translate-y-full'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-4">

        <div
          className={`flex items-center justify-between h-16 px-5 rounded-2xl transition-all duration-300 ${
            isScrolled
              ? 'bg-black/70 backdrop-blur-xl border border-white/10 shadow-2xl'
              : 'bg-black/30 backdrop-blur-md border border-white/5'
          }`}
        >

          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img
              src="/images/nrfstr-logo.png"
              alt="NRFSTR"
              className="h-10 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          {/* NRFSTR Status Ticker */}
<div className="ticker-container">

  <div className="ticker-label">
    <span className="live-dot"></span>
    LIVE
  </div>

  <div className="ticker-window">

    <div className="ticker-track">

      <div className="ticker-content">
        <span>✦ Gigma AVAILABLE</span>
        <span>•</span>
        <span>ScriptOtter COMING SOON</span>
        <span>•</span>
        <span>AiM LC COMING SOON</span>
        <span>•</span>
        <span>NRFSTR — NORF STAR</span>
      </div>

      <div className="ticker-content" aria-hidden="true">
        <span>✦ Gigma AVAILABLE</span>
        <span>•</span>
        <span>ScriptOtter COMING SOON</span>
        <span>•</span>
        <span>AiM LC COMING SOON</span>
        <span>•</span>
        <span>NRFSTR — NORF STAR</span>
      </div>

    </div>

  </div>

</div>
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-2">

            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                  isActive(link.path)
                    ? 'bg-white text-black shadow-lg'
                    : 'text-white/70 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.name}
              </Link>
            ))}

          </div>


          {/* Mobile Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden h-10 w-10 flex items-center justify-center rounded-xl bg-white/10 text-white hover:bg-white/20 transition"
          >
            {isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>

        </div>


        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            isMobileMenuOpen
              ? 'max-h-96 opacity-100 mt-3'
              : 'max-h-0 opacity-0'
          }`}
        >

          <div className="bg-black/80 backdrop-blur-xl border border-white/10 rounded-2xl p-3 shadow-2xl">

            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-3 rounded-xl text-sm font-medium transition ${
                  isActive(link.path)
                    ? 'bg-white text-black'
                    : 'text-white/70 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.name}
              </Link>
            ))}

          </div>

        </div>

      </div>
    </nav>
  );
};

export default Navbar;